import { useEffect, useState } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { Loader2, Check } from 'lucide-react'
import { getSiteLinks, updateSiteLinks, type SiteLinks } from '../../api/site'

const CHAMPS: { key: keyof SiteLinks; label: string; aide: string }[] = [
  { key: 'lien_husqvarna', label: 'Visiter le site Husqvarna', aide: 'Section « Nos marques »' },
  { key: 'lien_honda', label: 'Visiter le site Honda', aide: 'Section « Nos marques »' },
  { key: 'lien_miimo', label: 'Découvrir les Miimo', aide: 'Carte Honda (Robots tondeuses)' },
  { key: 'lien_automower', label: 'Découvrir les Automower', aide: 'Carte Husqvarna (Robots tondeuses)' },
]

export function AdminLiens() {
  const qc = useQueryClient()
  const { data, isLoading } = useQuery({ queryKey: ['site-links'], queryFn: getSiteLinks })
  const [form, setForm] = useState<SiteLinks | null>(null)
  const [saved, setSaved] = useState(false)

  useEffect(() => { if (data) setForm(data) }, [data])

  const mut = useMutation({
    mutationFn: (f: SiteLinks) => updateSiteLinks(f),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['site-links'] })
      setSaved(true)
      setTimeout(() => setSaved(false), 2500)
    },
  })

  if (isLoading || !form) {
    return <div className="grid place-items-center py-20 text-ink/50"><Loader2 className="h-6 w-6 animate-spin" /></div>
  }

  const champ = 'w-full rounded-xl border border-navy/15 bg-white px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-orange'

  return (
    <div className="space-y-5">
      <p className="text-sm text-ink/55">
        Adresses ouvertes par les boutons « Visiter le site » et « Découvrir » de la page d'accueil.
      </p>

      {CHAMPS.map((c) => (
        <div key={c.key}>
          <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-ink/55">
            {c.label} <span className="font-normal normal-case text-ink/40">· {c.aide}</span>
          </label>
          <input
            type="url"
            value={form[c.key]}
            onChange={(e) => setForm({ ...form, [c.key]: e.target.value })}
            className={champ}
            placeholder="https://…"
          />
        </div>
      ))}

      <div className="flex items-center gap-3 pt-1">
        <button
          onClick={() => mut.mutate(form)}
          disabled={mut.isPending}
          className="inline-flex items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white hover:bg-navy-dk disabled:opacity-50"
        >
          {mut.isPending && <Loader2 className="h-4 w-4 animate-spin" />} Enregistrer
        </button>
        {saved && (
          <span className="inline-flex items-center gap-1 text-sm font-medium text-green-600">
            <Check className="h-4 w-4" /> Enregistré
          </span>
        )}
      </div>

      {mut.isError && (
        <p className="text-sm text-red-600">
          {(mut.error as any)?.response?.data?.detail || "Erreur lors de l'enregistrement."}
        </p>
      )}
    </div>
  )
}
